import { DownloadOutlined } from '@ant-design/icons'
import { Button, message } from 'antd'
import { ButtonProps } from 'antd/es/button'
import { FC } from 'react'
import downloadFileByBlob from '../../../helpers/download-file-by-blob'
import {
    buildShipmentSourceDownloadFileName,
    iterateShipmentSourceFiles,
} from '../../../helpers/shipment-source-files'
import useErrorModal from '../../../hooks/api/use-error-modal'
import { useLazyDownloadUploadedFileQuery } from '../../../store/api/upload-api'
import { useLazyGetShipmentByDocIdQuery } from '../../../store/api/shipments-api'
import { DocumentId } from '../../../types/strapi/strapi'

const POPULATE_SOURCE_FILES = {
    sourceFile: true,
    client: true,
    shipment_positions: {
        populate: { sourceFile: true },
    },
} as const

interface DownloadShipmentSourceFilesProps {
    shipmentDocumentId: DocumentId
    buttonProps?: ButtonProps
}

const DownloadShipmentSourceFiles: FC<DownloadShipmentSourceFilesProps> = ({
    shipmentDocumentId,
    buttonProps,
}) => {
    const docId = shipmentDocumentId

    const [fetchShipment, fetchState] = useLazyGetShipmentByDocIdQuery()
    const [downloadUploadedFile, downloadState] = useLazyDownloadUploadedFileQuery()

    useErrorModal(fetchState, 'Ошибка загрузки исходников отгрузки')
    useErrorModal(downloadState, 'Ошибка скачивания файла')

    const onClick = async () => {
        if (!docId) return

        const res = await fetchShipment([docId, { populate: POPULATE_SOURCE_FILES }])

        if ('error' in res && res.error) return
        if (!('data' in res) || !res.data?.data) return

        const data = res.data.data
        const clientName = data.client?.name
        const shipmentId = data.id

        let downloaded = 0

        for (const file of iterateShipmentSourceFiles(data)) {
            const name = buildShipmentSourceDownloadFileName(clientName, shipmentId, file.name)
            const downloadRes = await downloadUploadedFile(file.url)
            if ('error' in downloadRes && downloadRes.error) return
            if (!downloadRes.data) {
                message.error(`Не удалось скачать «${file.name}»`)
                return
            }
            downloadFileByBlob(downloadRes.data, name)
            downloaded++
        }

        if (downloaded === 0) {
            message.info('Нет прикреплённых исходников')
        }
    }

    const isLoading =
        fetchState.isLoading ||
        fetchState.isFetching ||
        downloadState.isLoading ||
        downloadState.isFetching

    return (
        <Button
            size="small"
            icon={<DownloadOutlined />}
            title="Скачать все исходники (отгрузка и позиции)"
            onClick={onClick}
            disabled={!docId}
            loading={isLoading}
            {...buttonProps}
        />
    )
}

export default DownloadShipmentSourceFiles
